export const MENU_BRANDS_COUNT = 50;
